import { Pagination } from "@arco-design/web-react";

type Props = { page: number; pageSize: number; total: number; onPageChange: (page: number) => void; onPageSizeChange: (pageSize: number) => void };

/** 确认件列表分页。 */
export function FulfillmentOrderPaginationBar({ page, pageSize, total, onPageChange, onPageSizeChange }: Props) {
  return (
    <div className="fulfillment-order-pagination">
      <Pagination
        current={page}
        pageSize={pageSize}
        total={total}
        showJumper
        sizeCanChange
        onChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
      />
    </div>
  );
}
